module.exports = __webpack_public_path__ + "static/media/check-in.399d89ab.png";